import { forwardRef } from 'react';
import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M16.1156 4.88442C16.6281 5.39699 16.6281 6.22801 16.1156 6.74058L11.0437 11.8125L16.1156 16.8844C16.6281 17.397 16.6281 18.228 16.1156 18.7406C15.603 19.2531 14.772 19.2531 14.2594 18.7406L8.25942 12.7406C8.01328 12.4944 7.875 12.1606 7.875 11.8125C7.875 11.4644 8.01328 11.1306 8.25942 10.8844L14.2594 4.88442C14.772 4.37186 15.603 4.37186 16.1156 4.88442Z'
            />
        </SvgIcon>
    );
});
